import React, { useRef, useState } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EventIcon from "@mui/icons-material/Event";
import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import "react-datepicker/dist/react-datepicker.css";

// import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { useEffect } from "react";

// import GstReportCard from "./gstReportCard";
import SearchIcon from "@mui/icons-material/Search";
import dayjs from "dayjs";
import axios from "../../../utils/axios";
import {
  getEndOfMonth,
  getFirstDateOfCurrentMonthPayloadFormate,
  getFirstDateOfMonth,
  getLastDateOfCurrentMonthPayloadFormat,
  getStartOfMonth,
  payloadDateFormat,
} from "../../../utils/commonUtils";
import {
  getOverallCounterDetail,
  getOverallCounterDetailXlsx,
} from "../totalCounterSaleReport.jsx/reportsApi";
import CounterSalesItemCard from "../totalCounterSaleReport.jsx/counterItemCard";
import SelectItemsCard from "./SelectItemsCard";
import TableReport from "./table.jsx";
import { useNavigate } from "react-router";
import { ArrowBackIcon } from "../../../common/icon.js";
const CounterSaleOfSelectedItem = () => {
  const [open, setOpen] = useState(false);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);

  function addLeadingZero(value) {
    return value < 10 ? "0" + value : value;
  }

  const displayDateFormat = () => {
    var currentDate = new Date();
    let dateContainer = String(currentDate).split(" ");
    var year = dateContainer[2];
    var month = dateContainer[1];
    var day = dateContainer[3];
    var formattedDate =
      year + "-" + addLeadingZero(month) + "-" + addLeadingZero(day);
    return formattedDate;
  };

  const [gstReports, setgstReports] = useState({
    totalSales: "",
    gstReports: [],
  });
  const today = dayjs();
  const firstDayOfMonth = today.startOf("month");
  const [counterSales, setCounterSales] = useState();
  const [billFilter, setBillFilter] = useState("cash");
 const navigate = useNavigate();

  const [date, setDate] = useState(null);
  const [displayEndDate, setDisplayEndDate] = useState(null);
  const [dateFocused, setDateFocused] = useState(false);

  const [SelectedStartDate, setSelectedStartDate] = useState(firstDayOfMonth);
  const [endDate, setEndDate] = useState(today.format("YYYY-MM-DD"));

  const [startDateFormat, setstartDateFormat] = useState(
    firstDayOfMonth.format("YYYY-MM-DD")
  );

  const datePickerRef = useRef();
  const datePickerRef2 = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const getCounterSales = async (param) => {
    await getOverallCounterDetail(param)
      .then((res) => {
        console.log("GetOverall ", res?.data?.data);
        setCounterSales(res?.data?.data);
      })
      .catch((err) => {
        console.log("err ", err);
      });
  };
  const datePickerOnChange = (newValue) => {
    setSelectedStartDate(newValue);

    const formattedDisplayDate = newValue.toDate
      ? newValue.toDate().toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : newValue.format("DD-MMMM-YYYY");

    let dateContainer = String(formattedDisplayDate).split(" ");
    const [day2, month2, year2] = dateContainer;
    const formattedDate2 = `${day2}-${month2}-${year2}`;
    setDate(formattedDate2);

    // ✅ API date format in ISO
    setstartDateFormat(dayjs(newValue).toISOString());

    setStartDateOpen(false);
    setEndDateOpen(true);
  };

  const datePickerOnChangeEnd = (newValue) => {
    setSelectedEndDate(newValue);

    const formattedDisplayDate = newValue.toDate
      ? newValue.toDate().toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : newValue.format("DD-MMMM-YYYY");

    let dateContainer = String(formattedDisplayDate).split(" ");
    const [day2, month2, year2] = dateContainer;
    const formattedDate2 = `${day2}-${month2}-${year2}`;
    setDisplayEndDate(formattedDate2);

    // ✅ API date format in ISO
    setEndDate(dayjs(newValue).toISOString());

    setEndDateOpen(false);
  };

  // useEffect(() => {
  //   console.log("datE ", payloadDateFormat());
  //   getCounterSales({
  //     fromDate: startDateFormat,
  //     toDate: endDate,
  //   });
  // }, []);
  const [SelectedEndDate, setSelectedEndDate] = useState(dayjs());
  const downloadXLSXFile = async (param) => {
    try {
      // const response = await axios.post(
      //   getOverallCounterDetailXlsx,
      //   param,
      //   {
      //     responseType: "blob",
      //   }
      // );

      const response = await getOverallCounterDetailXlsx(param, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };
  //   const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [mount, setMount] = useState(false);
  useEffect(() => {
    // Only fetch if item is selected (optional)
    // if (selectedItem  ) {
    if (mount) {
      getCounterSales({
        fromDate: startDateFormat,
        toDate: endDate,
        itemId: selectedItem?.id,
        // billerId: selectedItem?.id,
      });
    }

    // }
  }, [startDateFormat, endDate, selectedItem]);
  useEffect(() => {
    setMount(true);
    console.log("selectedItem ", selectedItem);
  }, []);
  return (
    <>
      <Grid
        container
        sx={{
          p: "17px 30px",
          display: "flex",
          background: "#ede9ff",
        }}
      >
        {" "}
        <Grid container alignItems="center" spacing={2}>
          {/* Back Icon */}
          <Grid item>
            <ArrowBackIcon
              sx={{ cursor: "pointer" }}
              onClick={() => navigate("/home")}
            />
          </Grid>
          <Grid
            item
            xs
          
          >
            {" "}
            <Box
              sx={{
                background:
                  "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                padding: "10px",
                mt: "10px",
                borderRadius: "5px",
                color: "#01008B",
                textAlign: "left",
                marginBottom: "20px",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "20px",
                fontWeight: 500,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "18px" },
                }}
              >
                Counter Sale Of Selected Item
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={5}
          sx={{ paddingTop: "20px", paddingRight: "10px" }}
        >
          <TextField
            fullWidth
            size="small"
            label={selectedItem?.itemDescription ? "Selected Item" : "Select"}
            disabled={true}
            sx={{
              backgroundColor: "white",
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 500,
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
              borderRadius: 1,
              border: "none",
              "& fieldset": { border: "none" },
            }}
            value={selectedItem?.itemDescription || ""}
            onChange={(e) => setSelectedItem(e.target.value)}
            InputProps={{
              sx: {
                // cursor: "pointer",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },

                // mr: 1,
              },
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleOpen}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            InputLabelProps={{
              sx: {
                // cursor: "pointer",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },

                // mr: 1,
              },
              shrink: Boolean(selectedItem?.itemDescription),
            }}
          />
        </Grid>
        <Modal open={open} onClose={handleClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              //   width: "60vw", // responsive width
              //   maxHeight: "90vh",
              bgcolor: "background.paper",
              p: 4,
              borderRadius: 2,
              boxShadow: 24,
              overflowY: "auto", // scroll if content overflows
            }}
          >
            <SelectItemsCard
              open={open}
              handleClose={handleClose}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
            />
          </Box>
        </Modal>
        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          sx={{
            p: "4px 0px",
            paddingRight: "10px",
          }}
        >
          <TextField
            label="Date"
            value={
              SelectedStartDate && SelectedEndDate
                ? `${dayjs(SelectedStartDate).format("DD-MM-YYYY")} to ${dayjs(
                    SelectedEndDate,
                  ).format("DD-MM-YYYY")}`
                : SelectedStartDate
                  ? `${dayjs(SelectedStartDate).format("DD-MM-YYYY")}`
                  : ""
            }
            id="datepickerfield"
            placeholder="Select date range"
            size="small"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <CalendarMonthIcon
                  sx={{
                    cursor: "pointer",
                    mr: 1,
                  }}
                  onClick={() => setStartDateOpen(true)}
                />
              ),
              sx: {
                background: "#fff",
                borderRadius: 1,
                cursor: "pointer",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                fontWeight: 500,
                border: "none",
                "& fieldset": { border: "none" },
              },
            }}
            onClick={() => setStartDateOpen(true)}
            sx={{ width: "100%", height: "50px", mt: 2 }}
          />

          <Box sx={{ position: "relative" }}>
            <LocalizationProvider
              dateAdapter={
                require("@mui/x-date-pickers/AdapterDayjs").AdapterDayjs
              }
            >
              <DatePicker
                open={startDateOpen}
                onOpen={() => setStartDateOpen(true)}
                onClose={() => setStartDateOpen(false)}
                value={SelectedStartDate}
                onChange={(val) => {
                  datePickerOnChange(val);
                }}
                maxDate={SelectedEndDate || undefined}
                slotProps={{
                  popper: {
                    placement: "bottom-start",
                    anchorEl:
                      typeof window !== "undefined"
                        ? document.querySelector("#datepickerfield")
                        : undefined,
                    sx: { zIndex: 1500 },
                  },
                  textField: { style: { display: "none" } },
                }}
              />
            </LocalizationProvider>

            <LocalizationProvider
              dateAdapter={
                require("@mui/x-date-pickers/AdapterDayjs").AdapterDayjs
              }
            >
              <DatePicker
                open={endDateOpen}
                onOpen={() => setEndDateOpen(true)}
                onClose={() => setEndDateOpen(false)}
                value={SelectedEndDate}
                onChange={(val) => {
                  datePickerOnChangeEnd(val);
                }}
                minDate={SelectedStartDate || undefined}
                slotProps={{
                  popper: {
                    placement: "bottom-start",
                    anchorEl:
                      typeof window !== "undefined"
                        ? document.querySelector("#datepickerfield")
                        : undefined,
                    sx: { zIndex: 1500 },
                  },
                  textField: { style: { display: "none" } },
                }}
              />
            </LocalizationProvider>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Box
            sx={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              fullWidth
              sx={{
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                backgroundColor: "#0000A3",
                padding: "6px 40px",
                margin: { sm: "20px", xs: "0px" },
                borderRadius: "8px",
                marginBottom: "15px",
              }}
              onClick={() =>
                downloadXLSXFile({
                  fromDate: startDateFormat,
                  toDate: endDate,
                  itemId: selectedItem?.id,
                })
              }
              endIcon={<FileDownloadIcon />}
            >
              Download
            </Button>
          </Box>
        </Grid>
        <Grid
          item
          xs={"auto"}
          sx={{
            padding: "10px 16px",
            margin: "8px 8px 0px 0",
            fontWeight: "500",
            backgroundColor: "#CCCCFF",
            borderRadius: "8px",
          }}
        >
          <Typography
            component="p"
            sx={{
              display: "flex",
              alignItems: "center",
              marginLeft: "5px",
              color: "#00008B",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Total Quantity:&nbsp;&nbsp;&nbsp;
            </Typography>
            <Typography
              component="span"
              sx={{
                fontWeight: "bold",
                marginLeft: "8px",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              {counterSales?.totalQuantity?.toFixed(2) ?? (0)?.toFixed(1)}
            </Typography>
          </Typography>
        </Grid>
        <Grid
          item
          xs={"auto"}
          sx={{
            padding: "8px 16px",
            margin: "8px 8px 0px 0",
            fontWeight: "500",
            backgroundColor: "#CCCCFF",
            borderRadius: "8px",
          }}
        >
          <Typography
            component="p"
            sx={{
              display: "flex",
              alignItems: "center",
              marginLeft: "5px",
              color: "#00008B",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Total Amount :&nbsp;&nbsp;&nbsp;
            </Typography>
            <Typography
              component="span"
              sx={{
                fontWeight: "bold",
                marginLeft: "8px",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              ₹{counterSales?.totalAmount?.toFixed(2) ?? (0)?.toFixed(1)}
            </Typography>
          </Typography>
        </Grid>
        <Grid
          item
          xs={"auto"}
          sx={{
            padding: "8px 16px",
            margin: "8px 8px 0px 0",
            fontWeight: "500",
            backgroundColor: "#CCCCFF",
            borderRadius: "8px",
          }}
        >
          <Typography
            component="p"
            sx={{
              display: "flex",
              alignItems: "center",
              marginLeft: "5px",
              color: "#00008B",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Daily Average :&nbsp;&nbsp;&nbsp;
            </Typography>
            <Typography
              component="span"
              sx={{
                fontWeight: "bold",
                marginLeft: "8px",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              {counterSales?.dailyAverage?.toFixed(2) ?? (0)?.toFixed(1)}
            </Typography>
          </Typography>
        </Grid>
        <Grid
          item
          xs={"auto"}
          sx={{
            padding: "8px 16px",
            margin: "8px 8px 0px 0",
            fontWeight: "500",
            backgroundColor: "#CCCCFF",
            borderRadius: "8px",
          }}
        >
          <Typography
            component="p"
            sx={{
              display: "flex",
              alignItems: "center",
              marginLeft: "5px",
              color: "#00008B",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Daily Amount :&nbsp;&nbsp;&nbsp;
            </Typography>
            <Typography
              component="span"
              sx={{
                fontWeight: "bold",
                marginLeft: "8px",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              ₹{counterSales?.dailyAmount?.toFixed(2) ?? (0)?.toFixed(1)}
            </Typography>
          </Typography>
        </Grid>
        {/* <Grid container>
          <Grid item xs={12}>
            <Grid container sx={{ p: "10px" }}>
              <Grid item xs={4}>
                <Typography
                  sx={{
                    fontSize: "15px",
                    overflow: "Hidden",
                    display: "-webkit-box",
                    "-webkit-line-clamp": "1",
                    "-webkit-box-orient": "vertical",
                    fontWeight: 700,
                    p: "0px 0.5rem",
                  }}
                >
                  Date
                </Typography>
              </Grid>

              <Grid item xs={4}>
                <Typography
                  sx={{
                    fontSize: "15px",
                    overflow: "Hidden",
                    display: "-webkit-box",
                    "-webkit-line-clamp": "1",
                    "-webkit-box-orient": "vertical",
                    fontWeight: 700,
                    p: "0px 0.5rem",
                  }}
                >
                  Qty
                </Typography>
              </Grid>

              <Grid
                item
                xs={4}
                sx={{
                  fontSize: "15px",
                  overflow: "Hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  "-webkit-line-clamp": "1",
                  "-webkit-box-orient": "vertical",
                  textAlign: "center",
                  fontWeight: 700,
                }}
              >
                Amount
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ height: "60vh", overflow: "auto" }}>
            {counterSales?.counterSalesDetails?.map((item, i) => {
              return (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  // lg={6}
                  key={"payamentRecpt" + i}
                  sx={{ p: "0px" }}
                >
                  <CounterSalesItemCard item={item} />
                </Grid>
              );
            })}
          </Grid>
        </Grid> */}
        <Box mt={4} sx={{ borderRadius: 2, background: "#fff", width: "100%" }}>
          <TableReport
            salesData={[]}
            data={counterSales?.counterSalesDetails ?? []}
          />
        </Box>
      </Grid>
    </>
  );
};
export default CounterSaleOfSelectedItem;
